export default __webpack_public_path__ + "static/media/plain-sticker-w.f774e28d.png";